import { render } from "./singleproject.vue?vue&type=template&id=04b1dc9c&scoped=true"
import script from "./singleproject.vue?vue&type=script&lang=js"
export * from "./singleproject.vue?vue&type=script&lang=js"

import "./singleproject.vue?vue&type=style&index=0&id=04b1dc9c&lang=css"
import "./singleproject.vue?vue&type=style&index=1&id=04b1dc9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b1dc9c"]])

export default __exports__